import React from "react";
import '../App.css';

function Footer() {
    return (
        <footer>&#169; 2023 #VANLIFE</footer>
    )
}

export default Footer;